import { Component, OnInit, Renderer2, ViewChild, ElementRef, Directive } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart, Route } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { AuthService } from 'src/app/core/services/auth.service';
import swal from 'sweetalert2';
import { HttpService } from 'src/app/core/http/http.service';
import { API_ROUTES } from 'src/app/core/http/api-routes';
import { ChangePasswordComponent } from 'src/app/pages/users/change-password/change-password.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'src/app/core/services/toastr.service';
import { AttendenceService } from 'src/app/core/services/attendence.service';
import { DashAbsentsModuleComponent } from 'src/app/pages/dash-absents-module/dash-absents-module.component';
import { SinglePaymentComponent } from 'src/app/pages/students/single-payment/single-payment.component';
const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
    listTitles: any;
    location: Location;
    mobile_menu_visible: any = 0;
    private nativeElement: Node;
    private toggleButton: any;
    private sidebarVisible: boolean;
    private _router: Subscription;

    isDialogOpen = false;

    total: any = []
    attendeceSections: any = []
    finance: any = []
    // re;
    // stdSection;
    // absentCounts;
    // res;
    attadenceSummary: any = [];
    isAdmin: boolean
    @ViewChild('app-navbar-cmp', { static: false }) button: any;


  

    constructor(
        private dialog: MatDialog,
        private toastr: ToastrService,
        location: Location,
        private renderer: Renderer2,
        private element: ElementRef,
        private router: Router,
        private auth: AuthService,
        private httpApi: HttpService, 
        private attendenceService: AttendenceService,
        private elementRef: ElementRef,
       
        

    ) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }
    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;

        } else {
            setTimeout(function () {
                body.classList.add('sidebar-mini');

                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }
    hideSidebar() {
        const body = document.getElementsByTagName('body')[0];
        const sidebar = document.getElementsByClassName('sidebar')[0];

        if (misc.hide_sidebar_active === true) {
            setTimeout(function () {
                body.classList.remove('hide-sidebar');
                misc.hide_sidebar_active = false;
            }, 300);
            setTimeout(function () {
                sidebar.classList.remove('animation');
            }, 600);
            sidebar.classList.add('animation');

        } else {
            setTimeout(function () {
                body.classList.add('hide-sidebar');
                // $('.sidebar').addClass('animation');
                misc.hide_sidebar_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    async ngOnInit() {
        let { modules } = this.auth.user_data;
        this.listTitles = modules;
        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.sidebarClose();

            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });
        
    }


    searchAtt(){
        if (this.isDialogOpen) return;
        this.isDialogOpen = true;
        const dialogRef = this.dialog.open(DashAbsentsModuleComponent, {
          width: 'min(1100px, 96vw)',
          maxWidth: '96vw',
          panelClass: 'aad-dialog-panel',
          disableClose: true,
          hasBackdrop: true,
        });
        dialogRef.afterClosed().subscribe(result => {
            this.isDialogOpen = false;
          if (!result) {
            // this.ngOnInit();
          }
        });
      }

      
    singlePayment(){
        if (this.isDialogOpen) return;
        this.isDialogOpen = true;
        const dialogRef = this.dialog.open(SinglePaymentComponent, {
         
          width: '900px',
          disableClose: true,
          hasBackdrop: true
    
          
        });
        dialogRef.afterClosed().subscribe(result => {
            this.isDialogOpen = false;
          if (!result) {
            // this.ngOnInit();
          }
        });
      }

    onResize(event) {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    }
    sidebarOpen() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        setTimeout(function () {
            $toggle.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        } else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function () {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function () { //asign a function
            body.classList.remove('nav-open');
            this.mobile_menu_visible = 0;
            this.sidebarVisible = false;

            $layer.classList.remove('visible');
            setTimeout(function () {
                $layer.remove();
                $toggle.classList.remove('toggled');
            }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };
    sidebarClose() {
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');

        this.sidebarVisible = false;
        body.classList.remove('nav-open');
        // $('html').removeClass('nav-open');
        body.classList.remove('nav-open');
        if ($layer) {
            $layer.remove();
        }

        setTimeout(function () {
            $toggle.classList.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    // console.log(subtitle)
                    // console.log(titlee)
                    if (subtitle === titlee) {
                        return this.listTitles[i].children[j].title;
                    }
                }
            }
        }
        return 'Dashboard';
    };
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    };

    /** Single Payment is hidden when offline is 0. */
    get showSinglePaymentButton(): boolean {
        const offline = this.auth?.user_data?.offline;
        if (offline === 0 || offline === '0') {
            return false;
        }
        return this.getTitle() === 'Dashboard';
    }

    logoutAction() {
        swal.fire({
            title: 'Are you sure?',
            text: "Are you sure to Logout",
            icon: 'error',
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-secondary',
            },
            confirmButtonText: 'Yes, Logout!',
            buttonsStyling: false
        }).then(async (result) => {
            try {
                if (result.value) {
                    this.auth.logOut();
                    this.router.navigate(['/users/login'])
                }
            } catch (error) {
                // this.auth.logOut();
                // this.router.navigate(['/users/login'])
            }
        });
    };
    changePass() {
        const dialogRef = this.dialog.open(ChangePasswordComponent, {
            width: "800px", // Adjust the width as needed
            height: "400px", // Adjust the height as needed
            hasBackdrop: false,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                this.ngOnInit();
            }
        });
    }
}
